import React, { useContext } from 'react';
import { pick, prop } from 'ramda';
import { useLocation } from 'react-router-dom';
import { getURLParam } from 'js/utils/url.util';
import { WebContent } from 'js/components/system/WebContent';
import { DefaultHeader } from 'js/components/main/DefaultHeader';
import { AppContext } from 'js/components/system/App/store/context';
import { componentService } from 'js/services/component.service';
import { useDeviceSelector, usePageSelector, useAppSelector } from 'js/store/hooks';

export const Header = () => {
    const { addLoadingPromise } = useContext(AppContext);
    const location = useLocation();
    const { isDesktop } = useDeviceSelector(pick(['isDesktop']));
    const headerWCID = useAppSelector(prop('headerWCID'));
    const { headerWcId, overrideHeader } = usePageSelector(pick(['headerWcId', 'overrideHeader']));
    const hideHeaderByUrl = getURLParam(location.search, 'hideHeader') === '1';
    const hideDesktopHeaderByUrl = getURLParam(location.search, 'showHeaderOnlyOnMobile') === '1';

    if (hideHeaderByUrl) {
        return null;
    }

    if (hideDesktopHeaderByUrl && isDesktop) {
        return null;
    }

    if (overrideHeader && !headerWcId) {
        return null;
    }

    if (overrideHeader && headerWcId) {
        return <WebContent id={headerWcId} addLoadingPromise={addLoadingPromise} />;
    }

    if (headerWCID) {
        return <WebContent id={headerWCID} addLoadingPromise={addLoadingPromise} />;
    }

    return <DefaultHeader />;
};

componentService.registerWebContentComponents({ Header });
